/*
 * The alert strip's alerts (Factorio's): each a kind with the hexes it's
 * about, worked out each state by the game's controls. A click on one
 * goes to its next hex.
 */

import { createSignal } from "solid-js";

export interface Alert {
  /** Its kind ("lost", "raid"), or a problem's group ("inputs|Steelworks|Coal"). */
  id: string;
  /** The icon: a good's name (its icon) or the alert's own. */
  icon: string;
  /** In words, with the count ("3 structures lost"). */
  label: string;
  /** What to do or where it is, for the tip. */
  detail: string;
  /** The hexes it's about (cycled by clicks). */
  at: [number, number][];
}

const [alerts, setAlerts] = createSignal<Alert[]>([]);
export { alerts, setAlerts };

let looker: (at: [number, number]) => void = () => {};
export function setAlertLook(f: (at: [number, number]) => void): void {
  looker = f;
}
const next = new Map<string, number>();
/** Goes to the alert's next hex. */
export function cycleAlert(a: Alert): void {
  if (!a.at.length) return;
  const i = (next.get(a.id) ?? 0) % a.at.length;
  next.set(a.id, i + 1);
  looker(a.at[i]);
}
